import { lazy, type ComponentType } from 'react';

/**
 * A part of the app that loads on its own (Phase 26: the start bundle only
 * carries what Home needs). Once its code has arrived it renders straight
 * away, with no loading step; `preloadScreens` fetches every one of them
 * (the shell does it when the device is idle after start, tests before they run).
 */
const all = new Set<() => Promise<unknown>>();

export function lazyScreen<P extends object, M>(load: () => Promise<M>, pick: (m: M) => ComponentType<P>): ComponentType<P> & { preload: () => Promise<void> } {
  let Loaded: ComponentType<P> | null = null;
  const preload = () =>
    load().then((m) => {
      Loaded = pick(m);
    });
  all.add(preload);
  const Lazy = lazy(() => preload().then(() => ({ default: Loaded! })));
  const Screen = (props: P) => (Loaded ? <Loaded {...props} /> : <Lazy {...props} />);
  return Object.assign(Screen, { preload });
}

export function preloadScreens(): Promise<unknown> {
  return Promise.all([...all].map((load) => load().catch(() => undefined)));
}
